<lib-base-signal-input
  [label]="label()"
  [hint]="helpText()"
  [showRequired]="showRequiredIndicator()"
  [showError]="showError()"
  [errorMessage]="errorMessage()"
  [disabled]="disabled()"
  [showExternalLabel]="true"
>
  <div input class="w-full">
    <div
      #autocompleteContainer
      class="w-full"
    ></div>
  </div>
</lib-base-signal-input>